module.exports = __webpack_public_path__ + "img/4.c25a3020.jpg";